import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";

import {
  GridFilterInputValueProps,
  gridFilterModelSelector,
  GridFilterModel,
  GridFilterItem,
} from "@mui/x-data-grid-premium";

import MultiSelectFilter from "../../DataGrid/MultiSelectFilter";
import { generateRandomNumber } from "utils/common";

const TopListedMultiselect: React.FC<GridFilterInputValueProps> = (props) => {
  const { item, apiRef } = props;
  const [options, setOptions] = useState<string[]>([]);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { apiRequest } = useApi();
  const { showError } = useError();

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await apiRequest<any>(
          `/brand_utils/top_listed_options`,
          {
            method: "GET",
          }
        );
        if (response.data) {
          setOptions(response.data["top_listed_options"]);
        }
      } catch (error) {
        console.error(error);
        showError(`Failed to fetch top listed classifications.`);
      } finally {
        setLoading(false);
      }
    };
    fetchOptions();
  }, []);

  const handleFilterChange = (values: string[]) => {
    setSelectedValues(values);

    const currentFilters: GridFilterItem[] =
      gridFilterModelSelector(apiRef).items;

    // Filter out the existing filters for this specific field
    const updatedFilters = currentFilters.filter(
      (filter) => filter.field !== item.field
    );

    // Add new filters for the selected values
    values.forEach((value) => {
      updatedFilters.push({
        id: generateRandomNumber(undefined, 100),
        field: item.field,
        operator: "contains",
        value,
      });
    });

    // Update the filter model with the new filters
    const newFilterModel: GridFilterModel = {
      ...gridFilterModelSelector(apiRef),
      items: updatedFilters,
    };

    apiRef.current.setFilterModel(newFilterModel);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <MultiSelectFilter
      options={options}
      selectedValues={selectedValues}
      onChange={handleFilterChange}
      label="Contains"
    />
  );
};

export default TopListedMultiselect;
